import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'
import { index as app} from './app.action'
import { changeAlert } from './alert.action'
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'ACCOUNT_INDEX',
    STORE: 'ACCOUNT_STORE',
    DESTROY: 'ACCOUNT_DESTROY',
    CHANGE: 'ACCOUNT_CHANGE',
    SUCCESS: 'ACCOUNT_SUCCESS',
    ERROR: 'ACCOUNT_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = () => dispatch => {
    return HttpAuth.get('/account')
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
}

// STORE

export const store = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/account', data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(success(true))
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(changeScreen({ open: false }))
                    dispatch(app())
                }
            }
        })
        .catch(erro => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof erro.response !== 'undefined') {
                if(erro.response.status === 400) {
                    if(typeof erro.response.data === 'object'){
                        if(erro.response.data.errors) {
                            dispatch(error(erro.response.data.errors))
                        }
                        if(erro.response.data.msg) {
                            dispatch(changeAlert({
                                open: true,
                                msg: erro.response.data.msg,
                                class: erro.response.data.class
                            }))
                        }

                        if(typeof erro.response.data.error_code !== undefined) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'accounts.edit'
                            }))
                            
                            return false
                        }
                        
                        if(typeof erro.response.data.error !== undefined) {
                            if(typeof erro.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: erro.response.data.error
                                }))
                            }
                        }

                        if(typeof erro.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: erro.response.data.msg,
                                class: erro.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/account/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error_code !== undefined) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'accounts.edit'
                            }))
                            
                            return false
                        }
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// UPDATE

export const update = (id, data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/account/'+id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            dispatch(success(true))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(changeScreen({ open: false }))
                    dispatch(app())
                }
            }
        })
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error_code !== undefined) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'accounts.update.delete'
                            }))
                            
                            return false
                        }
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// NOTIFICATION

export const notificationUpdate = (id, data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/account/notification/'+id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            dispatch(success(true))
            
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))

                    return '200'
                }
            }
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.delete('/account/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(destroyResponse(id))
            }
        })
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error_code !== undefined) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'accounts.update.delete'
                            }))
                            
                            return false
                        }
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}